import * as React from 'react'

import {
  reportStartSurveyClick,
  reportViewSurveyBanner
} from '../../../common/analytics/surveyBannerAnalytics'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../../../common/utils/localStorageHelpers'
import CloseIcon from '../icons/close'
import OkIcon from '../icons/ok'

import * as styles from './searchSurveyBanner.module.css'

interface IProps {
  surveyUrl: string
  bannerText: string
  siteId: string
}

interface IState {
  dismissed: boolean
}

const SurveyLink = ({
  onClick,
  surveyUrl,
  bannerText
}: {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => any
  surveyUrl: string
  bannerText: string
}) => {
  const classNames = `${styles.surveyText} fds-u-hide-medium-and-above`

  return (
    <a
      onClick={onClick}
      href={surveyUrl}
      target="_blank"
      className={classNames}
    >
      {bannerText}
    </a>
  )
}

const SurveyButton = ({
  onClick,
  surveyUrl
}: {
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => any
  surveyUrl: string
}) => {
  const classNames = `fds-u-hide-medium-and-below fds-c-button--3d -color-primary`

  return (
    <a
      onClick={onClick}
      href={surveyUrl}
      target="_blank"
      className={classNames}
    >
      Share your experience
    </a>
  )
}

class SearchSurveyBanner extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { dismissed: this.isDismissed() }
  }

  public componentDidMount() {
    if (!this.state.dismissed) {
      reportViewSurveyBanner(this.gaLabel())
    }
  }

  public render() {
    const { surveyUrl, bannerText } = this.props

    if (this.state.dismissed) {
      return null
    }

    // Search Survey Banner temporarily uses Alert styles until there is a Survey Component in Design System.
    // Alert styles should be replaced with appropriate Survey Component styles by Sept 2017
    return (
      <div className="grid-container">
        <div
          className={`fds-c-alert-box ${
            styles.backgroundDark
          } fds-u-mt2 -type-success`}
        >
          <div className="fds-c-alert-box__icon">
            <OkIcon />
          </div>
          <div className="fds-c-alert-box__message">
            <div className="fds-c-text-body -size-s fds-u-m0">
              <p className={styles.surveyText}>
                <span className="fds-u-hide-medium-and-below">
                  {bannerText}
                </span>
                <SurveyLink
                  onClick={this.onStartSurvey}
                  surveyUrl={surveyUrl}
                  bannerText={bannerText}
                />
              </p>
            </div>
          </div>
          <SurveyButton onClick={this.onStartSurvey} surveyUrl={surveyUrl} />
          <span onClick={this.onDismiss} className={styles.surveyDismissIcon}>
            <CloseIcon />
          </span>
        </div>
      </div>
    )
  }

  private localStorageKey() {
    return `${this.props.siteId}-search-survey-banner-visibility`
  }

  private gaLabel() {
    return `${this.props.siteId.toUpperCase()} Search Survey`
  }

  private dismiss() {
    setLocalStorageItem(this.localStorageKey(), 'hidden')
    this.setState({ dismissed: true })
  }

  private isDismissed() {
    return getLocalStorageItem(this.localStorageKey(), 'visible') === 'hidden'
  }

  private onDismiss = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault()
    this.dismiss()
  }

  private onStartSurvey = (event: React.MouseEvent<HTMLAnchorElement>) => {
    reportStartSurveyClick(this.gaLabel())
    this.dismiss()
  }
}

export default SearchSurveyBanner



// WEBPACK FOOTER //
// ./client/components/banners/searchSurveyBanner.tsx